import { call, put } from 'redux-saga/effects';
import * as configActions from '../actions/config';
import * as api from './api';

const fxApiUrl = process.env.REACT_APP_FX_API_URL;

function* getConfig() {
  try {
    const url = `${fxApiUrl}config`;
    const response = yield call(fetch, url, {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch config: ${response.status} ${response.statusText}`);
    }

    const data = yield response.json();
    yield put({
      type: configActions.GET_CONFIG_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({ type: configActions.GET_CONFIG_ERROR, payload: error });
  }
}

function* getCurrencyConfig({ payload: currencyCode }) {
  try {
    const url = currencyCode ? `${fxApiUrl}config?currencyCode=${encodeURIComponent(currencyCode)}` : `${fxApiUrl}config`;

    const response = yield call(fetch, url, {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch currency config: ${response.status} ${response.statusText}`);
    }

    const data = yield response.json();
    yield put({
      type: configActions.GET_CURRENCY_CONFIG_SUCCESS,
      payload: { currencyCode, data },
    });
  } catch (error) {
    yield put({ type: configActions.GET_CURRENCY_CONFIG_ERROR, payload: { currencyCode, error } });
  }
}

function* getReferenceCountries() {
  try {
    const countries = yield call(api.getReferenceCountries);
    yield put({
      type: configActions.GET_REFERENCE_COUNTRIES_SUCCESS,
      payload: { countries: Array.isArray(countries) ? countries : [] },
    });
  } catch (error) {
    yield put({ type: configActions.GET_REFERENCE_COUNTRIES_ERROR, payload: error });
  }
}

const sagas = [
  [configActions.GET_CONFIG, getConfig],
  [configActions.GET_CURRENCY_CONFIG, getCurrencyConfig],
  [configActions.GET_REFERENCE_COUNTRIES, getReferenceCountries],
];

export default sagas;
